import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';
const fields = 'id data _version _deleted';
const normalise = value => Array.isArray(value) ? value.map(normalise) :
  value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map(key => [key, normalise(value[key])])) : value;
const sameData = (stored, requested) => {
  try { return JSON.stringify(normalise(JSON.parse(stored))) === JSON.stringify(normalise(requested)); }
  catch { return false; }
};
export const projectRecordId = (userId, projectId) => `${userId}::project::${projectId}`;
export async function loadProjectProgress(projectId) {
  const user = await getCurrentUser();
  const id = projectRecordId(user.userId, projectId);
  const result = await generateClient().graphql({
    query: `query ProjectProgress($id: ID!) { getProgress(id: $id) { ${fields} } }`,
    variables: { id }, authMode: 'userPool',
  });
  if (result.errors?.length) throw new Error('Unable to load saved progress');
  const record = result.data?.getProgress;
  const data = record && !record._deleted ? JSON.parse(record.data) : null;
  return { id, version: record?._version, data };
}
export async function saveProjectProgress(record, data) {
  const user = await getCurrentUser();
  if (!record.id.startsWith(`${user.userId}::project::`)) throw new Error('Account changed');
  const update = Boolean(record.version);
  const operation = update ? 'updateProgress' : 'createProgress';
  const inputType = update ? 'UpdateProgressInput' : 'CreateProgressInput';
  const result = await generateClient().graphql({
    query: `mutation SaveProject($input: ${inputType}!) { ${operation}(input: $input) { ${fields} } }`,
    variables: { input: { id: record.id, data: JSON.stringify(data), ...(update ? { _version: record.version } : {}) } },
    authMode: 'userPool',
  });
  const saved = result.data?.[operation];
  if (result.errors?.length || !saved || !sameData(saved.data, data)) throw new Error('Progress changed on another device. Reload before saving again.');
  return { id: saved.id, version: saved._version, data };
}
